import { base64Decode, base64Encode, isBase64 } from '@/utils/base64';
import { Assignment } from './Assignment';
import { EnrollmentType } from './Enrollment';
import { ThreadFlaggedStatus } from './Filters';
import { Item } from './Item';
import { Person } from './Person';
import { Question } from './Question';
import { ThreadRepliesCount } from './ThreadRepliesCount';

export enum ThreadGradeType {
  REPLY = 'REPLY',
  RESPONSE = 'RESPONSE',
  NOGRADE = 'NOGRADE',
}

export interface ThreadLike extends Item {
  questionId: number;
  question?: Question;

  personId: number;
  person: Person;

  threadId?: number;
  thread?: Thread;
}

export interface Thread extends Item {
  assignmentId: number;
  assignment?: Assignment;
  courseSectionId?: number;
  enrollmentType?: EnrollmentType | null;
  questionId: number;
  question?: Question;
  personId: number;
  person?: Person;
  prompt: string;
  parentThreadId?: number;
  parentThread?: Thread;
  replyCount?: ThreadRepliesCount;
  likeCount?: ThreadReplyLikeCount;
  iLike?: ThreadLike;
  isFlagged?: boolean;
  flagComment?: string;
  approvedAt?: Date;
  approvedId?: number | null;
  approvedBy?: Person;
  gradeType?: ThreadGradeType;
}

export interface ThreadReplyLikeCount extends Item {
  count: number;
  threadId: number;
}

export const translateThreadFromTransport = (attributes: Thread) => {
  return {
    ...attributes,
    prompt: isBase64(attributes.prompt) ? base64Decode(attributes.prompt) : attributes.prompt,
  };
};

export const translateThreadForTransport = (attributes: Thread) => {
  return {
    ...attributes,
    prompt: !isBase64(attributes.prompt) ? base64Encode(attributes.prompt) : attributes.prompt,
  };
};

export const isThreadResponse = (thread: Thread) => thread.gradeType === ThreadGradeType.RESPONSE;

export const isThreadReply = (thread: Thread) => thread.gradeType === ThreadGradeType.REPLY;

export const isThreadExtraReply = (thread: Thread) => thread.gradeType === ThreadGradeType.NOGRADE;

export const isThreadFlagged = (thread: Thread) => thread.isFlagged && thread.isActive;

export const isThreadRejected = (thread: Thread) => thread.isFlagged && !thread.isActive;

export const isThreadApproved = (thread: Thread) =>
  !thread.isFlagged && thread.isActive && thread.approvedId != null;

export const getThreadFlaggedStatus = (thread: Thread) => {
  if (isThreadFlagged(thread)) {
    return ThreadFlaggedStatus.FLAGGED;
  }

  if (isThreadApproved(thread)) {
    return ThreadFlaggedStatus.APPROVED;
  }

  if (isThreadRejected(thread)) {
    return ThreadFlaggedStatus.REJECTED;
  }
};
